import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { trackHeapEvent } from "@hoteltradergit/ht-telemetry-ui-lib";
import ChevronRightIcon from "../../assets/img/action-center/chevron-right-white.svg";
import { Can, P } from "../../rbac";
import {
  BLACK_FRIDAY_COPY,
  BLACK_FRIDAY_HEAP,
} from "../../constants/blackFriday";
import {
  getBlackFridayOffer,
  formatOfferDeadline,
} from "../../utils/blackFriday";
import "./BlackFridayStrip.scss";

/**
 * Home-page strip, in the opportunities banner's place, while the property has
 * a live Black Friday offer (EO-1892; copy from the Notion spec). Its CTA
 * opens the offer's Create Promo panel via onReview.
 */
const BlackFridayStrip = ({ card, onReview }) => {
  const recommendationId = card?.recommendationId;

  useEffect(() => {
    if (recommendationId) {
      trackHeapEvent(BLACK_FRIDAY_HEAP.stripShown, {
        recommendation_id: recommendationId,
      });
    }
  }, [recommendationId]);

  if (!card) return null;

  const { bookingStart } = getBlackFridayOffer(card);
  const publishBy = formatOfferDeadline(bookingStart);

  return (
    <Can permission={P.Home.ActionCenter.CreatePromo}>
      <section className="bf-strip">
        <div className="bf-strip__text">
          <p className="bf-strip__headline">
            <span className="bf-strip__accent">
              {BLACK_FRIDAY_COPY.stripLead}
            </span>
            {` ${BLACK_FRIDAY_COPY.stripMiddle} `}
            <span className="bf-strip__accent">
              {BLACK_FRIDAY_COPY.stripTail}
            </span>
          </p>
          {publishBy && (
            <p className="bf-strip__subline">
              {BLACK_FRIDAY_COPY.stripSubline(publishBy)}
            </p>
          )}
        </div>
        <button
          type="button"
          className="bf-strip__cta"
          onClick={onReview}
          data-heap-id={BLACK_FRIDAY_HEAP.stripReviewId}
        >
          {BLACK_FRIDAY_COPY.stripCta}
          <img src={ChevronRightIcon} alt="" className="bf-strip__cta-icon" />
        </button>
      </section>
    </Can>
  );
};

BlackFridayStrip.propTypes = {
  card: PropTypes.shape({
    recommendationId: PropTypes.string,
    promoObjectDr: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  onReview: PropTypes.func,
};

export default BlackFridayStrip;
